export default __webpack_public_path__ + "static/media/monitoring_icon_blue.06c45a7d.svg";